import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { GainLossTypography } from "@rentablo/components";

interface HorizontalBarChartRowProps {
  title: string;
  valueFormatted: string;
  isPositive: boolean;
  barLeftPosition: number;
  displayBarWidth: number;
  value: number;
  isFake?: boolean;
  color?: string;
  textColor: "monochrome" | "gainLoss";
  alignPercentage: "left" | "right";
  isLastRow: boolean;
  spacing: number;
}

export const HorizontalBarChartRow = ({
  title,
  valueFormatted,
  value,
  barLeftPosition,
  displayBarWidth,
  isFake = false,
  textColor,
  color,
  alignPercentage,
  isLastRow,
  spacing,
}: HorizontalBarChartRowProps) => {
  return (
    <Box display="flex" flexDirection="column" width="100%" gap={spacing}>
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        sx={{
          filter: isFake ? "blur(4px)" : "none",
        }}
      >
        <Box minWidth="80px" flexShrink={0}>
          <Typography variant="body3" color="textSecondary">
            {title}
          </Typography>
        </Box>
        {textColor === "gainLoss" ? (
          <GainLossTypography
            value={value}
            variant="body3"
            minWidth="60px"
            flexShrink={0}
            textAlign={alignPercentage}
          >
            {valueFormatted}
          </GainLossTypography>
        ) : (
          <Typography
            variant="body3"
            minWidth="60px"
            flexShrink={0}
            textAlign={alignPercentage}
            color="textPrimary"
          >
            {valueFormatted}
          </Typography>
        )}
        <Box
          flexGrow={1}
          position="relative"
          sx={{
            minHeight: "20px",
            marginLeft: "20px",
          }}
        >
          <Box
            height={20}
            borderRadius={value > 0 ? "0 5px 5px 0" : "5px 0 0 5px"}
            sx={{
              backgroundColor: color,
              width: `${displayBarWidth}%`,
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              left: `${barLeftPosition}%`,
              transition: "width 0.3s, left 0.3s",
            }}
          />
        </Box>
      </Box>
      {!isLastRow && <Divider sx={{ margin: "0!important" }} />}
    </Box>
  );
};
